// src/components/PairWithCarousel.jsx
import React from "react";
import { Link } from "react-router-dom";

const formatMoney = (amount, currency = "GBP") => {
  const n = Number(amount ?? 0);
  const isWhole = Math.abs(n - Math.round(n)) < 1e-6;
  return new Intl.NumberFormat("en-GB", {
    style: "currency",
    currency,
    minimumFractionDigits: isWhole ? 0 : 2,
    maximumFractionDigits: isWhole ? 0 : 2,
  }).format(n);
};

function PairWithCarousel({ relatedProducts }) {
  if (!relatedProducts || relatedProducts.length === 0) return null;

  return (
    <section className="mt-12 w-full">
      {/* Full-width but centred heading */}
      <h2 className="mb-6 text-center text-customBlue tracking-[0.25em] italic uppercase">
        You may also like...
      </h2>

      {/* Full-width row, items centred */}
      <div className="flex justify-center gap-4 overflow-x-auto pb-2 px-4 md:px-8">
        {relatedProducts.map((rp) => {
          const id = rp.id?.split("/")?.pop();
          const handle = rp.handle;
          const productUrl = handle ? `/products/${handle}` : `/product/${id}`;          const img = rp.images?.[0];
          const variants = rp.variants || [];
          const v0 = variants[0];

          const priceAmount =
            v0?.price?.amount != null ? Number(v0.price.amount) : null;
          const currency = v0?.price?.currencyCode || "GBP";
          const priceText =
            priceAmount != null ? formatMoney(priceAmount, currency) : "";

          return (
            <Link
              key={rp.id}
              to={productUrl}
              className="group block w-44 sm:w-52 flex-shrink-0"
            >
              <div className="relative overflow-hidden">
                <div className="aspect-[3/4] bg-gray-100">
                  {img && (
                    <img
                      src={img.url || img.src}
                      alt={rp.title}
                      className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                      loading="lazy"
                    />
                  )}
                </div>

                {/* Hover overlay with name + price */}
                <div className="pointer-events-none absolute inset-0 bg-black/40 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-end">
                  <div className="w-full p-3 text-white text-xs sm:text-sm italic">
                    <div className="mb-1">{rp.title}</div>
                    {priceText && <div>{priceText}</div>}
                  </div>
                </div>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}

export default PairWithCarousel;
